import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import './FormTextField.scss';

export interface FormTextFieldProps {
    [key: string]: any,
    ref?: React.RefObject<FormTextField>,
    type?: string;
    value?: string;
    label?: string;
    filter?: string | RegExp;
    minLength?: any;
    maxLength?: any;
    required?: boolean;
    onFocus?(event: React.FormEvent<HTMLInputElement>): void;
    onChange?(event: React.FormEvent<HTMLInputElement>): void;
    onValidate?(val?: string): boolean;
}

export interface FormTextFieldState {
    errorMsg?: string
}

class FormTextField extends Component<FormTextFieldProps, FormTextFieldState> {
    constructor(props: FormTextFieldProps) {
        super(props);
        this.state = {
            errorMsg: undefined
        };
    }

    onValidate(): boolean {
        if (this.props.onValidate) {
            return this.props.onValidate(this.props.value);
        }
        return true;
    }

    validate = (): boolean => {
        const ret = this.onValidate();
        if (!ret) {
            this.setState({ errorMsg: this.props.errorMsg });
        } else {
            this.setState({ errorMsg: undefined });
        }
        return ret;
    }

    onBlur = () => {
        this.validate();
    }

    render() {
        return (
            <div className={this.props.className} id={this.props.id}>
                <span className="p-float-label">
                    <InputText minLength={this.props.minLength} maxLength={this.props.maxLength} keyfilter={this.props.filter} name={this.props.name}
                        className="input-text" type={this.props.type} value={this.props.value} onChange={this.props.onChange}
                        onBlur={this.onBlur} required={(this.props.required === undefined) ? true : this.props.required}
                        onFocus={this.props.onFocus}
                    />
                    <label className="label-name">{this.props.label}</label>
                </span>
                {this.state.errorMsg &&
                    <div className="error-container">
                        <p className="error-message">
                            {this.state.errorMsg}
                        </p>
                    </div>
                }
            </div>
        )
    }
}

export default FormTextField;